import { STORE_REPLACE_CARD_ONBOARDING_MVP_2_AMOUNT_TO_CHARGE } from '@perpay-web/fintech/constants/actionTypes';

export const replaceAmountToCharge = (payload) => ({
    type: STORE_REPLACE_CARD_ONBOARDING_MVP_2_AMOUNT_TO_CHARGE,
    payload,
});
